import { FeedbackCommentDto, FeedbackCommentModel } from '../types/feedback-comment'
import { transformUser } from './feedback-user'

export const transformComment = (
  { comment, user }: FeedbackCommentDto,
  isSystem: boolean,
): FeedbackCommentModel | undefined => {
  if (!comment) return undefined

  return {
    user: transformUser(user),
    text: comment,
    isSystem,
  }
}
